import "./about.css"
import React from "react"
import { FaInstagram, FaGithub, FaDev, FaLinkedin } from 'react-icons/fa';
import Areeb from "../Assets/areeb.png"

class About extends React.Component {
    constructor(){
        super()
        this.state = {
             
        }
    }
    render(){
        return(
            <div id="about">
                <div className="hero-img">
                    <img src={Areeb} alt="areeb"/>
                    <div className="social-links-desktop">
                        <a href="https://github.com/areeburrub" rel="noreferrer" target="_blank"><FaGithub /></a>
                        <a href="https://dev.to/areeburrub" rel="noreferrer" target="_blank"><FaDev /></a>
                        <a href="https://instagr.am/areeb.ur_rub" rel="noreferrer" target="_blank"><FaInstagram /></a>
                        <a href="https://in.linkedin.com/in/areeburrub" rel="noreferrer" target="_blank"><FaLinkedin /></a>
                    </div>
                </div>
                <div className="hero-sec">
                    <h1 id="hero-heading">Areeb ur&nbsp;Rub</h1>
                    <p className="hero-txt">
                        Hey, I am a Tech-Enthusiast <br />
                        I love to try and explore. <br />
                        Learning and Building Everyday. <br />
                        more about me on social handels.

                    </p>
                    <a href="#contact">
                        <button>Contact Me</button>
                    </a>
                    <div className="social-links-mobile">
                        <a href="https://github.com/areeburrub" rel="noreferrer" target="_blank"><FaGithub /></a>
                        <a href="https://dev.to/areeburrub" rel="noreferrer" target="_blank"><FaDev /></a>
                        <a href="https://instagr.am/areeb.ur_rub" rel="noreferrer" target="_blank"><FaInstagram /></a>
                        <a href="https://in.linkedin.com/in/areeburrub" rel="noreferrer" target="_blank"><FaLinkedin /></a>
                    </div>
                </div>
            </div>
        );
    }
}


export default About;
